import { FormattedHTMLMessage } from 'react-intl'
import React from 'react'
import { messages } from '../../Name.full'

// eslint-disable-next-line react/prop-types
export function getFullNameInputInfoText({ hasFullNameInfoText }) {
  const { fullname_info_text } = messages
  return hasFullNameInfoText ?  <FormattedHTMLMessage {...fullname_info_text} /> : null
}